import React from 'react';
import { Button, Modal } from 'antd';
import { confirmDeclineInvitation } from '../popup/confirm';
const confirm = Modal.confirm;

const BtnDeclineInvitation = ({ handleClick }) => {
  const confirmPopup = () => {
    confirm({
      ...confirmDeclineInvitation,
      onOk: close => {
        close();
        handleClick('revoke');
      },
    });
  };

  return (
    <Button
      className="add-employee__reset"
      onClick={confirmPopup}
      style={{ width: '100%' }}
      type="danger"
    >
      Отклонить запрос
    </Button>
  );
};

export default BtnDeclineInvitation;
